import React, { useState, useEffect } from 'react';
import {
    Box,
    Typography,
    Chip,
    Divider,
} from '@mui/material';
import { Tag, apiService } from '../services/api';

interface PrimaryTagFilterProps {
    selectedPrimaryTagId?: number;
    onPrimaryTagSelect: (tagId?: number) => void;
}

const PrimaryTagFilter: React.FC<PrimaryTagFilterProps> = ({
    selectedPrimaryTagId,
    onPrimaryTagSelect,
}) => {
    const [tags, setTags] = useState<Tag[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchTags();
    }, []);

    const fetchTags = async () => {
        try {
            setLoading(true);
            const response = await apiService.getTags();
            setTags(response.tags || []);
        } catch (err) {
            console.error('Error fetching tags:', err);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <Typography variant="body2">Loading primary tags...</Typography>;
    }

    return (
        <Box sx={{ mb: 3 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
                Filter by Tag
            </Typography>

            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
                <Chip
                    label="All Images"
                    onClick={() => onPrimaryTagSelect(undefined)}
                    variant={selectedPrimaryTagId === undefined ? 'filled' : 'outlined'}
                    color={selectedPrimaryTagId === undefined ? 'primary' : 'default'}
                />

                {tags.map((tag) => (
                    <Chip
                        key={tag.id}
                        label={tag.name}
                        onClick={() => onPrimaryTagSelect(tag.id)}
                        variant={selectedPrimaryTagId === tag.id ? 'filled' : 'outlined'}
                        sx={{
                            backgroundColor: selectedPrimaryTagId === tag.id ? tag.color : 'transparent',
                            borderColor: tag.color,
                            color: selectedPrimaryTagId === tag.id ? 'white' : tag.color,
                            '&:hover': {
                                backgroundColor: tag.color,
                                color: 'white',
                            },
                        }}
                    />
                ))}
            </Box>

            <Divider />
        </Box>
    );
};

export default PrimaryTagFilter;